import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import mutations from './mutations'
Vue.use(Vuex)

const state = {
  UserBasicInfo: null,
  Telnum: null,
  Credential: null,
  Menu: null,
  MenuActive: [0, 0],
  Course: [],
  CourseActive: [0, 0],
  IndexActive: '',
  Group: [],
  PartList: null,
  Bread: [],
  Definition: 'LD',
  PlayAuth: null,
  SubCourse: null,
  InfomationStatus: false, // 新增：指令信息默认关闭
  serverTimeOffset: 0 // 新增：服务器与本地时间差（毫秒）
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})
